import React from 'react'
import BlockUi from 'react-block-ui'
import {lifecycle} from 'recompose'
import withLayout from '../../../layout/withLayout'
import TaskList from './TaskList'
import Overview from './Overview'
import CommentList from './CommentList'
import StateTransitionLog from './StateTransitionLog'
import TechnicalLog from './TechnicalLog'
import SalesOrderCustomerWidgetContainer
    from '../../../sales-order/component/task-widget/SalesOrderCustomerWidgetContainer'
import SentEmailWidgetContainer from '../../../sales-order/component/task-widget/SentEmailWidgetContainer'
import InvoiceListWidgetContainer from '../../../sales-order/component/task-widget/InvoiceListWidgetContainer'
import PaymentListWidgetContainer from '../../../sales-order/component/task-widget/PaymentListWidgetContainer'
import SalesOrderOverviewWidgetContainer
    from '../../../sales-order/component/task-widget/SalesOrderOverviewWidgetContainer'
import InitialHesitationWidgetContainer
    from '../../../sales-order/component/task-widget/InitialHesitationWidgetContainer'
import {getUIDefinitionByStateName} from '../../ui-definition/ui-definition'
import {NAME_COMPONENT_MAPPING} from './name-component-mapping'
import ImprintScanStatusWidget from '../../../sales-order/component/task-widget/ImprintScanStatusWidget'
import VoucherWidgetContainer from '../../../sales-order/component/task-widget/VoucherWidgetContainer'
import WhatsappMessagesWidgetContainer from "../../../whatsapp-messages/component/WhatsappMessagesWidgetContainer";

const ComponentWidgetList = (props) => {
    const {definition} = props
    const {widgetList} = definition
    if (!widgetList) {
        return null
    }
    return (
        <div>
            {
                widgetList.map((widget, index) => {
                    const {component, widgetProps = {}} = widget
                    const Component = NAME_COMPONENT_MAPPING[component]
                    return (
                        <Component
                            key={index}
                            readOnly={false}
                            {...widgetProps}
                            {...props} />
                    )
                })
            }
        </div>
    )
}

const SalesOrderProcess = (props) => {
    const processNames = [
        'salesorder-shop-scan',
        'salesorder-shop-scan-new',
        'salesorder-treatment',
        'salesorder-refinement-production',
        'salesorder-check-in'
    ];
    const {processInstance, fetching} = props
    const definition = getUIDefinitionByStateName(processInstance.currentStateName)
    const isSetOrShopScanProcess = processInstance.processName === 'salesorder-shop-scan'
        || processInstance.processName === 'salesorder-shop-scan-new'
        || processInstance.processName === 'salesorder-set'
    const isWhatsappWidgetVisible = processNames.includes(processInstance.processName);
    return (
        <BlockUi tag="div" blocking={fetching}>
            <Overview {...props} />
            <SalesOrderOverviewWidgetContainer/>
            <ComponentWidgetList definition={definition} {...props} />
            <CommentList {...props} />
            {isSetOrShopScanProcess && <InitialHesitationWidgetContainer/>}
            <SalesOrderCustomerWidgetContainer/>
            {isSetOrShopScanProcess && <VoucherWidgetContainer {...props} />}
            <SentEmailWidgetContainer/>
            {isWhatsappWidgetVisible && <WhatsappMessagesWidgetContainer/>}
            <InvoiceListWidgetContainer/>
            <PaymentListWidgetContainer/>
            <TaskList processTaskList={processInstance.processTaskList}/>
            <StateTransitionLog {...props} processStateHistoryList={processInstance.processStateHistoryList}/>
            <ImprintScanStatusWidget context={processInstance.context} readOnly={true} changeProcessContext={() => {
            }} saveProcessContext={() => {
            }} salesOrder={processInstance.objectDetail} validationMessageList={[]}/>
            <TechnicalLog {...props} processLogList={processInstance.processLogList}/>
        </BlockUi>
    )
}

const InstanceDetail = (props) => {
    const {processInstance} = props

    if (!processInstance) {
        return null
    }

    return <SalesOrderProcess {...props} />
}

export default lifecycle({
    componentDidMount() {
        if (this.props.processInstanceId) {
            this.props.findProcessInstance(this.props.processInstanceId)
        }
        if (this.props.masterObject && this.props.masterId) {
            this.props.findProcessInstanceByMasterId(this.props.masterObject, this.props.masterId)
        }
    },
})(withLayout(InstanceDetail))



// WEBPACK FOOTER //
// ./src/modules/process/component/instance-detail/InstanceDetail.js